import type { HeadlineResponse } from '@on3/api';
import { Link } from '@on3/ui-lib/components/Link';
import { ResizedImage } from '@public/components/Image/ResizedImage';

import styles from './ArticleFeedAlternate.module.scss';

export const ArticleFeedAlternate = ({
  featuredImage,
  title,
  fullUrl,
}: HeadlineResponse) => {
  return (
    <article>
      <Link className={styles.inner} href={fullUrl}>
        {featuredImage && (
          <ResizedImage
            {...featuredImage}
            className={styles.image}
            fit="cover"
            gravity="0.5x0.5"
            height={100}
            quality={90}
            width={100}
          />
        )}

        <div className={styles.title}>
          <h4>{title}</h4>
        </div>
      </Link>
    </article>
  );
};
